<template>
    <div class="qrcode">
        <div class="title">社交媒体</div>
        <div class="tips">通过网络社交媒体及时关注我们的动态</div>

        <div class="qrcode-content">
            <div class="qrcode-item mini-program">
                <img src="../assets/image/qrcode_1.webp" class="vue-lazy"/>
                <div class="desc">扫码进入小程序</div>
            </div>

            <div class="qrcode-item">
                <img src="../assets/image/qrcode_2.webp" class="vue-lazy"/>
                <div class="desc">扫码关注公众号</div>
            </div>

            <div class="qrcode-item">
                <img src="../assets/image/qrcode_3.webp" class="vue-lazy"/>
                <div class="desc">扫码添加微信</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'QrcodeComp',
    mounted() {
        this.$el.style.setProperty('--animate-duration', '0.8s');
    }
}
</script>

<style scoped lang="scss">
.qrcode {
    padding: 80px;
    box-sizing: border-box;
    width: 100%;
    background-color: #FFF;

    .title {
        color: #000000;
        font-family: "Inter";
        font-size: 30px;
        font-style: normal;
        font-weight: 700;
        line-height: 36px;
        text-align: center;
        margin-bottom: 18px;
    }

    .tips {
        color: #4B5563;
        font-family: "Inter";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        text-align: center;
        margin-bottom: 50px;
    }

    .qrcode-content {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 48px;

        .qrcode-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 12px;

            img {
                width: 200px;
                height: 200px;
            }

            .desc {
                color: #4B5563;
                font-family: "Inter";
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 24px;
            }
        }
    }
}

@media (max-width: 768px) {
    .qrcode {
        padding: 40px 24px;

        .title {
            font-size: 24px;
            margin-bottom: 12px;
        }

        .tips {
            font-size: 14px;
            margin-bottom: 32px;
        }

        .qrcode-content {
            flex-direction: column;
            gap: 12px;

            .qrcode-item {
                img {
                    width: 100%;
                    height: auto;
                    max-width: 280px;
                }

                .desc {
                    font-size: 14px;
                }
            }

            .mini-program {
                img {
                    width: 60%;
                }
            }
        }
    }
}
</style>